<template>
  <v-row wrap no-gutters class="justify-center align-center">
    <v-spacer></v-spacer>
    <v-col cols="4" sm="4" class="range_element">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="fromDate"
            label="From Date"
            prepend-icon="event"
            v-on="on"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker v-model="fromDate" @input="menu = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="4" sm="4" class="range_element">
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="toDate"
            label="To Date"
            prepend-icon="event"
            v-on="on"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker v-model="toDate" @input="menu1 = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-spacer></v-spacer>
  </v-row>

  <!--  CALL COMPONENT FROM PARENT EXAMPLE
              <AthletesDropdown v-on:change-athlete="onChangeAthlete"/>
              import AthletesDropdown from "../shared/athletes_dropdown_example.vue";-->
</template>

<script>
export default {
  props: {
    parentFromDate: {
      type: String,
      default: ""
    },
    parentToDate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      menu: false,
      menu1: false,
      fromDate: new Date(new Date().setDate(new Date().getDate() - 1825))
        .toISOString()
        .substr(0, 10),
      toDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 6,
        new Date().getDate()
      )
        .toISOString()
        .substr(0, 10),
      on: ""
    };
  },
  created() {
    //
    //
    if (this.parentFromDate) {
      this.fromDate = this.parentFromDate;
    }
    if (this.parentToDate) {
      this.toDate = this.parentToDate;
    }

    if (
      (!this.toDate || !this.fromDate) &&
      !(Object.entries(this.$route.query).length === 0)
    ) {
      const { fromDate, toDate } = this.$route.query;
      //assign to current instance variables
      this.fromDate = fromDate;
      this.toDate = toDate;
    }
  },
  watch: {
    fromDate: function() {
      this.$emit("change-fromDate", this.fromDate);
    },
    toDate: function() {
      this.$emit("change-toDate", this.toDate);
    }
  }
};
</script>
<style lang="scss">
.range_element {
  display: flex;
  align-items: center !important;

  .v-text-field__details {
    display: none;
  }
}
</style>
